export const NAFED_ROLES = [
  { value: "HEAD_OFFICE", label: "NAFED Head Office", needsApproval: false },
  { value: "STATE_BRANCH", label: "State Branch", needsApproval: true },
  { value: "DISTRICT_REGISTRAR", label: "District Registrar", needsApproval: true },
  { value: "STATE_REGISTRAR", label: "State Registrar", needsApproval: true },
  { value: "BANK", label: "Bank", needsApproval: true },
  { value: "CA", label: "CA", needsApproval: true },
  { value: "PMC", label: "PMC Agency", needsApproval: true },
  { value: "PACS", label: "PACS / Society", needsApproval: true },
  { value: "CONTRACTOR", label: "Contractor", needsApproval: true },
  { value: "ENGINEER", label: "Engineer", needsApproval: true },
  { value: "ACCOUNTANT", label: "Accountant", needsApproval: true },
];

export const ROLE_DASHBOARD_PATH = {
  HEAD_OFFICE: "/nafed/head",
  STATE_BRANCH: "/nafed/branch",
  PMC: "/nafed/pmc",
  PACS: "/nafed/apply-godown",
  CONTRACTOR: "/tender/contractor",
  ENGINEER: "/tender/engineer/dashboard",
  ACCOUNTANT: "/accounting",
  BANK: "/agency/dashboard",
  CA: "/agency/dashboard",
  DISTRICT_REGISTRAR: "/nafed/district",
STATE_REGISTRAR: "/nafed/state-registrar",
};